import React from 'react';
import * as IptC from './_ccbIptC';
import * as TextC from './_ccbTextC';
import * as BtnC from './_cccBtnC';
import * as GridC from './_cccGridC';
import * as LblC from './_cccLblC';
import * as BtnsC from './_ccmBtnsC';
import * as HdrC from './_ccmHdrC';
import * as RootC from './_ccmRootC';
import * as SchC from './_ccmSchC';
import * as TblC from './_ccmTblC';
import * as _cm from './_cm';
import { a } from './_cmABT';
import * as _cmFTH from './_cmFTH';
import * as _cr from './_cr';
import * as _gv from './_gv';
import * as _ls from './_csLcl';
import { useNgnz } from './_csNgn';
import * as _hm from './_hm';
import * as _ht from './_ht';

import * as icv from './icv';
import * as icvBaseM10Rz from './icvBaseM10Rz';

const $cz = {
  tgt: '役割',
};

let $_41z = {
  _41rz: {},
  _411s: [],
} as _ht.dz;
let $_40rs = {} as _ht.dz;

let $_41rs = [] as _ht.ls;

let $_41r_fst = -1;

const $schz = {
  word: '',
};

const $schAsync = async (
  frcUdt: () => void
) => {
  $_41rs = await _cmFTH.loadLsAsync2({
    tgt: '_41r.load_41zLsAsync',
    lwrz: {
      _411s: false,
    },
    ... $schz,
  });
  if (frcUdt) frcUdt();
};

export const R = (pz: {
  sRz: _ht.dz,
}) => {

  const _sPz = _ls.usePz({
    steps: [0],
    phs: 'd',
  });

  return (
    _cr.c(icvBaseM10Rz.N, {},
      _cr.c(RootC.N, {
        sPz: _sPz,
        hdrClds: [
          _cr.c(H, {
            sPz: _sPz,
          })
        ],
        schStlz: a(`dw/w3`),
        schClds: [
          _cr.c(S, {
            sPz: _sPz,
          })
        ],
        btnClds: [
          _cr.c(B, {
            sPz: _sPz,
          })
        ],
        topStlz: a(`dw/w3`),
        topClds: [
          _cr.c(T, {
            sPz: _sPz,
          })
        ],
        cttStlz: a(`dw/w3`),
        cttClds: [
          _cr.c(C, {
            sPz: _sPz,
          })
        ],
      })
    )
  );

};

export const H = (pz: {
  sPz: _ht.dz,
}) => {
  return (
    _cr.c(HdrC.N, {
      sPz: pz.sPz,
      abtz: icv.abtz.mainHdrz,
      cz: {
        tgt: $cz.tgt
      }
    })
  );
};

export const S = (pz: {
  sPz: _ht.dz,
}) => {
  return (
    _cr.c(SchC.N, {
      sPz: pz.sPz,
      abtz: {
        btnSchz: icv.abtz.btnSchz,
        gridSchz: icv.abtz.gridSchz,
      },
      schClds: [
        _cr.c(IptC.N, {
          cz: {
            bEdit: true,
            iptType: 't',
            vle: $schz.word,
            onChg: (_s: _ht.s) => {
              $schz.word = _s;
            },
          },
          iptPtyz: a(`ipt/${$cz.tgt}ID、${$cz.tgt}名 ipc/lt3`),
        }),
      ],
      onSch: () => $schAsync(pz.sPz.udtAll),
    })
  );
};

export const T = (pz: {
  sPz: _ht.dz,
}) => {

  const _udtThis = _ls.udtThis();
  const _gUserz = _gv.useUserz();

  React.useEffect(() => {
    if (
      _gUserz.crt._20rz._key > 0 && 
      pz.sPz.crt.steps[0] == 0
    ) {
      _hm.ectSrlAsync([
        async () => {
          $_40rs = await _cmFTH.loadLsAsync2({
            tgt: '_40r.load_40zLsAsync',
          });
        },
        async () => {
          await $schAsync(_udtThis);
        },
      ])
    }
  }, [
    _gUserz.crt._20rz._key,
    pz.sPz.crt.steps[0]
  ])

  const _hdrCs = [
    {
      boxStlz: a(`dw/f fd/rsc mb/1`),
      cellCs: [
        {
          boxStlz: a(`dw/15`),
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `${$cz.tgt}ID`,
            }),
          ]
        },
        {
          boxStlz: a(`f/2`),
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `${$cz.tgt}名`,
            }),
          ]
        },
        {
          boxStlz: a(`dw/10`),
          boxClds: [

            _cr.c(BtnC.N, {
              boxStlz: a(`dw/f sc/rd5`),
              lblCz: {
                text: ' ',
                textStlz: a('tc/lt9'),
              },
              frmCz: {
                boxStlz: a(`dw/f`),
                pslPtyz: {
                  onPrs: () => {
                    pz.sPz.set({
                      steps: [1],
                    })
                  }
                }            
              },
            }),

          ]
        }
      ]
    }
  ];

  const _bdyCs = $_41rs?.map((__41rz: _ht.dz) => {
    return (
      {
        boxStlz: a(`dw/f fd/rsc mb/1`),
        cellCs: [
          {
            boxStlz: a(`dw/15`),
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: `${__41rz._icn}`,
              }),
            ]
          },
          {
            boxStlz: a(`f/2 fd/rsc`),
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: `${__41rz._pfx}`,
              }),
            ]
          },
          {
            boxStlz: a(`dw/10`),
            boxClds: [

              _cr.c(BtnC.N, {
                abtz: icv.abtz.btnCfmz,
                lblCz: {
                  text: '確認・変更',
                },
                frmCz: {
                  pslPtyz: {
                    onPrs: () => {
                      $_41r_fst = __41rz._fst;
                      pz.sPz.set({
                        steps: [1],
                        phs: 'd',
                      })
                    }
                  }            
                },
              }),

            ]
          }
        ]
      }
    );
  });

  return (
    _cr.c(TblC.N, {
      abtz: icv.abtz.tblLinez,
      hdrCz: {
        abtz: icv.abtz.gridTblHdrz,
        lineCs: _hdrCs,
      },
      bdyCz: {
        abtz: icv.abtz.gridTblBdyz,
        lineCs: _bdyCs
      }
    })

  );

};

export const C = (pz: {
  sPz: _ht.dz,
}) => {

  const _udtThis = _ls.udtThis();

  React.useEffect(() => {
    if ( pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'c' ) { // 初期化
      $_41z = {
        _41rz: {},
        _411s: [],
      };
      _udtThis();
    };
    if ( pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'd' ) { // 更新
      _cmFTH.loadDzAsync2({
        tgt: '_41r.load_41zDzAsync',
        _41r_fst: $_41r_fst,
        lwrz: {
          _411s: true,
        },
      })
      .then((__41z: _ht.dz) => {
_hm.l(`icv_41M10Rz 320: ${_hm.s(__41z)}`)
        $_41z = __41z;
        _udtThis();
      });
    };
  }, [
    pz.sPz.crt.steps[0],
    pz.sPz.crt.phs
  ])

  const _hdrCs = [
    {
      cellCs: [
        {
          boxStlz: a(`f/1`),
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `使用機能`,
            }),
          ]
        },
      ]
    }
  ];

  const _bdyCs = _cm.nfd($_41z._411s, false).map((__411z: _ht.dz) => {
    //_hm.l(`icv_41M10Rz 348: ${_hm.s(__411z)}`);
    return (
      {
        cellCs: [
          {
            boxStlz: a(`f/1 pr/1`),
            boxClds: [
              _cr.c(IptC.N, {
                cz: {
                  iptType: 'p',
                  bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                  ls: $_40rs,
                  vle: __411z._411_40r1k,
                  onChg: (_dz: _ht.dz) => {
                    //_hm.l(`icv_41M10Rz 363: ${_hm.s(_dz)}`);
                    _cm.u(__411z, {
                      _411_40r1k: _dz.key,
                    })
                  }
                }
              }),
            ]
          },
          {
            boxStlz: a(`dw/btn f/n`),
            boxClds: [

              _hm.i(pz.sPz.crt.phs, ['c', 'u']) ?
              _cr.c(BtnC.N, {
                abtz: icv.abtz.btnDltz,
                frmCz: {
                  pslPtyz: {
                    onPrs: () => {
                      _cm.u(__411z, {
                        _dlt: 1,
                      });
                      _udtThis();
                    }
                  }            
                },
              })
              : undefined,

            ]
          }
        ]
      }
    );
  });

  if ( _hm.i(pz.sPz.crt.phs, ['c', 'u']) ) {
    _bdyCs.push(
      {
        cellCs: [
          {
            boxStlz: a(`f/n`),
            boxClds: [

              _cr.c(BtnC.N, {
                abtz: icv.abtz.btnAddz,                
                frmCz: {
                  pslPtyz: {
                    onPrs: () => {
                      $_41z._411s.push({});
                      _udtThis();
                    }
                  }
                },
              }),

            ]
          }
        ]
      }
    );
  }

  return (
    _cr.c(GridC.N, {
      boxStlz: a(`dw/f dh/f pt/1`),
      lineCs: [
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `${$cz.tgt}ID：`,
                    boxStlz: a(`dw/18`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $_41z._41rz?._icn,
                          onChg: (_s: _ht.s) => {
                            _cm.u($_41z._41rz, {
                              _icn: _s
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `${$cz.tgt}名：`,
                    boxStlz: a(`dw/18`),
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $_41z._41rz?._pfx,
                          onChg: (_s: _ht.s) => {
//                            $_41z._41rz._pfx = _s;
                            _cm.u($_41z._41rz, {
                              _pfx: _s
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },

        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f`),
              boxClds: [
                _cr.c(TblC.N, {
                  abtz: icv.abtz.tblLinez,
                  hdrCz: {
                    abtz: icv.abtz.gridTblHdrz,
                    lineCs: _hdrCs,
                  },
                  bdyCz: {
                    abtz: icv.abtz.gridTblBdyz,
                    lineCs: _bdyCs
                  }
                })
              ]
            },
          ]
        },

      ]
    })

  );

};

const $upsAsync = async (sCfmz: _ht.dz) => {
  await _cmFTH.ugdDzAsync2({
    tgt: '_41r.ugd_41zDzAsync',
    _41z: $_41z,
  })
  .then((__41z: _ht.dz) => {
    $_41r_fst = __41z._41rz._fst;
  });
};

export const B = (pz: {
  sPz: _ht.dz,
}) => {

  const _sNgnz = useNgnz();

  return (
    _cr.c(BtnsC.N, {
      sPz: pz.sPz,
      abtz: {
        gridBtnz: icv.abtz.gridBtnz,
        btnNextz: icv.abtz.btnNextz,
        btnBackz: icv.abtz.btnBackz,
      },
      cz: {
        tgt: $cz.tgt,
        onBackTop: () => {
          _sNgnz.setPageName('icvHomeM20Rz');
        },
        onCrtAsync: $upsAsync,
        onUdtAsync: $upsAsync,
      },
    })  
  );

};
